import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import ListingCard from 'client/components/ListingCard';
import SrFeedNoResults from 'client/components/SrFeedNoResults';
import SrButtonDeprecated from 'client/components/SrButtonDeprecated';
import SrListingCardLoader from 'client/components/SrListingCardLoader';
import SrPartnerListingCard, {
  SR_PARTNER_LISTING_CARD_TAG_THEME_GREEN,
} from 'client/components/SrPartnerListingCard';

import {
  APPLICATION_FORM_TYPE_RENTER_PREQUAL,
} from 'common/householdApplication/applicationFormFields';
import redirectToApplicationFormAction from 'client/actions/Household/redirectToApplicationForm';
import {
  FEED_CATEGORY_QUALIFIED_TO_RENT,
  FEED_CATEGORY_EXCLUSIVE_APARTMENTS,
} from 'common/feedCategoryConstants';
import {
  actionInitializeFeedCategoryState,
  actionFeedCategoryLoadlistings,
  withFeedCategory,
} from 'client/helpers/feedCategoryHelpers';
import {
  getListingManagedPhotoUrls,
  isFallbackImage,
} from 'common/listingHelpers';
import {
  getActiveApartmentSpecialDeals,
} from 'common/apartmentHelpers';
import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_CTA_CLICKED,
  ANALYTICS_EVENT_FEED_CATEGORY_VIEW_ALL_CLICK,
  ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_FILTERS_CLICK,
  ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_QUALIFICATIONS_CLICK,
} from 'client/analytics/eventList';

@withFeedCategory((props) => ({
  feedCategoryId: props.feedCategoryId,
}))
class SrFeedCategory extends Component {
  static propTypes = {
    feedCategoryId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    listings: PropTypes.array.isRequired,
    inProgress: PropTypes.bool.isRequired,
    highlight: PropTypes.bool,
    isFullyLoaded: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    listingPhotoResolution: PropTypes.number.isRequired,
    onViewedQualifedCategory: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    hideIfEmpty: PropTypes.bool,
  }

  componentDidMount() {
    const {
      feedCategoryId,
      listings,
      inProgress,
      isFullyLoaded,
      onViewedQualifedCategory,
      dispatch,
    } = this.props;

    if (!isFullyLoaded && !inProgress && !listings.length) {
      dispatch(actionInitializeFeedCategoryState, { feedCategoryId });
      dispatch(actionFeedCategoryLoadlistings, { feedCategoryId });
    }
    if (feedCategoryId === FEED_CATEGORY_QUALIFIED_TO_RENT) {
      onViewedQualifedCategory();
    }
  }

  _onChangeClick = () => {
    const { feedCategoryId, history, dispatch } = this.props;
    if (feedCategoryId === FEED_CATEGORY_QUALIFIED_TO_RENT) {
      analytics.track(ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_QUALIFICATIONS_CLICK, {
        feedCategoryId: feedCategoryId,
      });
      return dispatch(redirectToApplicationFormAction, {
        formType: APPLICATION_FORM_TYPE_RENTER_PREQUAL,
        shouldRestart: true,
      });
    }
    analytics.track(ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_FILTERS_CLICK, {
      feedCategoryId: feedCategoryId,
    });
    history.push('/search');
  }

  _onListingClick = () => {
    const { feedCategoryId } = this.props;
    analytics.track(ANALYTICS_EVENT_CTA_CLICKED, {
      feedCategoryId: feedCategoryId,
      ctaLocation: 'Feed Category Listing Click',
    });
  }

  _onViewAllClick = () => {
    const { history, feedCategoryId } = this.props;
    analytics.track(ANALYTICS_EVENT_FEED_CATEGORY_VIEW_ALL_CLICK, {
      feedCategoryId: feedCategoryId,
    });
    history.push(`/feed/${feedCategoryId}`);
  }

  render() {
    const {
      feedCategoryId,
      title,
      subtitle,
      total,
      hideIfEmpty,
      currentUser,
      listingPhotoResolution,
      inProgress,
      highlight,
      isFullyLoaded,
      market,
    } = this.props;

    const applicationSettings = (market.settings.application || {}).disabled || [];

    let _subtitle = subtitle;
    if (
      feedCategoryId === FEED_CATEGORY_QUALIFIED_TO_RENT
      && applicationSettings.includes('petCount')
    ) {
      _subtitle = 'You’re approved to rent based on your income and move date.';
    }

    const listings = feedCategoryId === FEED_CATEGORY_EXCLUSIVE_APARTMENTS
      ? this.props.listings
      : this.props.listings.filter((listing) => {
        const managedPhotoUrls = getListingManagedPhotoUrls({ listing });
        return managedPhotoUrls && managedPhotoUrls[0] && !isFallbackImage(managedPhotoUrls[0]);
      });

    if (hideIfEmpty && listings && listings.length === 0) {
      return null;
    }

    const subtitleIsOneLine = _subtitle.split('').length < 40;
    return (
      <div
        className={classNames('SrFeedCategory', {
          highlight: highlight,
        })}
      >
        <div className='SrFeedCategoryHeader'>
          <div className='SrFeedCategoryHeaderText'>
            <div className='SrFeedCategoryTitle'>
              <span>
                {title}
              </span>
            </div>
            <div
              className={classNames('SrFeedCategorySubtitle', {
                small: subtitleIsOneLine,
              })}
            >
              <span>
                {_subtitle}
              </span>
              {feedCategoryId === FEED_CATEGORY_QUALIFIED_TO_RENT && (
                <span className='editLink' onClick={this._onChangeClick}>
                  Edit my qualifications
                </span>
              )}
            </div>
          </div>
          {!inProgress && total !== 0 && (
            <SrButtonDeprecated
              className='grey small'
              rightIconClassName='blueArrow'
              text={`View all ${total}`}
              onClick={this._onViewAllClick}
            />
          )}
        </div>
        {(inProgress || (!isFullyLoaded && total === 0)) && (
          <div className='SrFeedCategoryGrid'>
            <SrListingCardLoader />
            <SrListingCardLoader />
            <SrListingCardLoader />
            <SrListingCardLoader className='categoryListing4' />
          </div>
        )}
        {!inProgress && listings.length > 0 && (
          <div className='SrFeedCategoryGrid'>
            {feedCategoryId !== FEED_CATEGORY_EXCLUSIVE_APARTMENTS && (
              listings.slice(0, 4).map((listing, index) => {
                return (
                  <ListingCard
                    className={`categoryListing${index + 1}`}
                    requestedFrom='feedCategory'
                    enableBookmarkButton
                    key={listing.id}
                    listing={listing}
                    currentUser={currentUser}
                    showRequestShowingButton={false}
                    photoResolution={listingPhotoResolution}
                    onClick={this._onListingClick}
                  />
                );
              })
            )}
            {feedCategoryId === FEED_CATEGORY_EXCLUSIVE_APARTMENTS && (
              listings.slice(0, 4).map(({ apartmentSpecialDeals, ...apartment }, index) => {
                const {
                  priceRange,
                  activeListings,
                  floorPlansCount,
                  hasSelfShowingUnits,
                  has3DTourUnits,
                } = apartment.fieldsForDisplay;
                const activeApartmentSpecialDeals = getActiveApartmentSpecialDeals({ apartmentSpecialDeals });
                const tags = activeApartmentSpecialDeals.map((apartmentSpecialDeal) => ({
                  label: (apartmentSpecialDeal.floorPlanId ? '*' : '') + apartmentSpecialDeal.headline,
                  theme: SR_PARTNER_LISTING_CARD_TAG_THEME_GREEN,
                  className: 'hideOnMobile',
                }));
                if (activeApartmentSpecialDeals.length) {
                  tags.push({
                    label: 'Special Deals',
                    theme: SR_PARTNER_LISTING_CARD_TAG_THEME_GREEN,
                    className: 'showOnMobile',
                  });
                }

                return (
                  <SrPartnerListingCard
                    className={`categoryApartment categoryApartment${index + 1}`}
                    key={apartment.id}
                    to={`/apartment/${apartment.id}`}
                    photos={apartment.photoUrls}
                    useCarousel
                    title={priceRange}
                    tags={tags}
                    caption={apartment.name}
                    stats={[
                      floorPlansCount
                        ? `${floorPlansCount} ${pluralize('floorplan', floorPlansCount)}`
                        : `${activeListings} unit ${pluralize('type', activeListings)}`,
                    ]}
                    hasSelfTour={hasSelfShowingUnits}
                    has3DTour={has3DTourUnits}
                  />
                );
              })
            )}
          </div>
        )}
        {!inProgress && listings.length === 0 && isFullyLoaded && (
          <SrFeedNoResults
            isCategoryQualified={feedCategoryId === FEED_CATEGORY_QUALIFIED_TO_RENT}
            onChangeClick={this._onChangeClick}
          />
        )}
        {!inProgress && total !== 0 && (
          <SrButtonDeprecated
            className='grey large'
            rightIconClassName='blueArrow'
            text={`View all ${total}`}
            onClick={this._onViewAllClick}
          />
        )}
      </div>
    );
  }
}

SrFeedCategory.displayName = 'SrFeedCategory';

export default SrFeedCategory;
